"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var ChainDependencies = exports.ChainDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createChainClass: _factoriesAny.createChainClass
};